let sequence = 0;

/**
 * Create an in-memory UI key without requiring a secure browser context.
 *
 * `crypto.randomUUID()` is unavailable on plain-HTTP origins in Chromium, while
 * these IDs only distinguish transient items within the current page.
 */
export function createTransientId(prefix: string): string {
  sequence += 1;
  return `${prefix}-${Date.now().toString(36)}-${sequence.toString(36)}`;
}
